import { FC } from 'react';
import { CoreMenu, CoreMenuItem } from '../_core/core-menu';
import {
	AddMoreTicketsIcon,
	EventDetailsIcon,
	Showable,
	TransferTicketIcon,
	UpgradeTicketIcon,
} from '../../';
import { menuItemStyles } from './ticket-menu.styles';

export interface TicketMenuProps {
	open: boolean;
	isOrderOwner?: boolean;
	anchorEl: HTMLElement | null;
	t?: (key: string) => string;

	onClose(): void;
	onOrderDetailsButtonClick?(): void;
	onUpgradeTicketButtonClick?(): void;
	onTransferTicketButtonClick?(): void;
	onAddMoreTicketsButtonClick?(): void;
}

export const TicketMenu: FC<TicketMenuProps> = (props) => {
	const {
		open,
		anchorEl,
		isOrderOwner = false,
		t,
		onClose,
		onTransferTicketButtonClick,
		onUpgradeTicketButtonClick,
		onOrderDetailsButtonClick,
		onAddMoreTicketsButtonClick,
	} = props;

	return (
		<CoreMenu
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			sx={{
				'& .MuiPaper-root': {
					width: { xs: '100%', sm: '250px' },
					marginTop: '-12px',
				}
			}}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
		>
			<Showable show={isOrderOwner && !!onOrderDetailsButtonClick}>
				<CoreMenuItem sx={menuItemStyles} onClick={onOrderDetailsButtonClick}>
					<EventDetailsIcon />
					{t ? t('tickets.ticket-menu.order-details') : 'Order Details'}
				</CoreMenuItem>
			</Showable>
			<Showable show={!!onTransferTicketButtonClick}>
			  <CoreMenuItem sx={menuItemStyles} onClick={onTransferTicketButtonClick}>
			  	<TransferTicketIcon />
			  		{t ? t('tickets.ticket-menu.transfer-ticket') : 'Transfer Ticket'}
			  	</CoreMenuItem>
			</Showable>
			<Showable show={!!onAddMoreTicketsButtonClick}>
			  <CoreMenuItem sx={menuItemStyles} onClick={onAddMoreTicketsButtonClick}>
			  	<AddMoreTicketsIcon />
			  	{t ? t('tickets.ticket-menu.add-more-tickets') : 'Add More Tickets'}
			  </CoreMenuItem>
			</Showable>
			<Showable show={!!onUpgradeTicketButtonClick}>
			  <CoreMenuItem sx={menuItemStyles} onClick={onUpgradeTicketButtonClick}>
			  	<UpgradeTicketIcon />
			  	{t ? t('tickets.ticket-menu.upgrade-ticket') : 'Upgrade Ticket'}
			  </CoreMenuItem>
			</Showable>
		</CoreMenu>
	);
};
